<div *ngIf="imgSrc || imgAlt" class="flex relative basis-[40px]">
  <img class="box-shadow rounded" [style]="{ width: imgWidth, height: imgHeight }" [src]="imgSrc" />
</div>
